import { useCallback, useMemo } from "react"
import { useLocation } from "react-router-dom"
import { stateURLRef } from "../refs"
import getURLSortState from "@/utilities/getURLSortState"

export default function useURLSorterState() {
    const { search } = useLocation()

    const sorter = useMemo(() => getURLSortState(search), [search])

    const setter = useCallback((state) => {
        const params = []
        for (const [key, order] of Object.entries(state)) {
            if (order === "asc") params.push(key)
            if (order === "desc") params.push("-" + key)
        }
        stateURLRef.current?.change?.((prev) => ({ ...prev, ordering: params.join(",") }))
    }, [])

    return [sorter, setter]
}
